<template>
  <div class="Dashboard">
    <div class="Dashboard__inner">
      <div class="Dashboard__layout">
        <div class="Dashboard__title">
          <h2>{{ title }}</h2>
        </div>
        <slot name="dashboardContent"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dashboard",
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

/*<dashboards>*/
.Dashboards {
  &__layout {
    display: flex;
    justify-content: space-between;
  }

  &__chart {
    height: 100%;
  }

  @media screen and (min-width: $min-xl) {
    &__sliders,
    &__chart {
      width: 48%;
    }
  }

  @media screen and (max-width: $max-lg) {
    &__layout {
      flex-direction: column;
    }
  }
}

/*<dashboard>*/
.Dashboard {
  &__inner {
    padding: 30px 0;
  }

  &__content,
  &__chart {
    margin: 20px 0 0;
  }

  &__chart {
    position: relative;

    &-labels {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      max-width: 500px;
      margin: 0 auto 40px;
    }

    &-label {
      display: flex;
      align-items: center;
      margin: 2.5px 0;

      div {
        width: 50px;
        height: 17.5px;
        margin: 0 5px 0 0;
      }

      small {
        line-height: 1.1;
      }
    }
  }

  &__layout {
    display: flex;
    flex-direction: column;
    background-color: $sec_bg;
    box-shadow: 0 0 2px 1px rgba(#333, 0.1);
    transition: box-shadow 0.4s;

    &:hover {
      box-shadow: 0 5px 10px 1px rgba(#555, 0.1);
    }
  }

  &__title {
    h2 {
      line-height: 1.1;
    }
  }

  @media screen and (min-width: $min-lg) {
    &__layout {
      padding: 30px 50px;
    }

    &__chart {
      position: relative;

      &-label {
        flex-basis: 33.333%;
      }
    }
  }

  @media screen and (max-width: $max-md) {
    &__layout {
      padding: 40px;
    }

    &__chart {
      position: relative;

      &-label {
        flex-basis: 50%;

        small {
          white-space: nowrap;
        }
      }
    }
  }

  @media screen and (min-width: $min-md) {
    &__layout {
      border-radius: 35px;
    }

    &__title {
      h1 {
        font-size: 36px;
      }

      h2 {
        font-size: 28px;
      }
    }
  }

  @media screen and (max-width: $max-sm) {
    &__layout {
      border-radius: 15px;
    }

    &__title {
      h1 {
        font-size: 28px;
      }

      h2 {
        font-size: 24px;
      }
    }
  }
}
</style>
